import React from "react";
import { Button, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { assetsPrefix } from "../utilities/utilities";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="w-screen h-screen bg-white">
      <div className="flex w-full h-full justify-center items-center">
        <div className="flex flex-col items-center w-80 text-center">
          <img
            style={{ width: "12rem" }}
            src={`${assetsPrefix}/images/trueCounselLogo.png`}
            alt="TrueCounsel"
            className="mb-6"
          />
          <Text className="text-5xl font-semibold text-blue-900 mb-2">404</Text>
          <Text className="text-xl text-blue-900 mb-2">Page not found</Text>
          <Text className="text-sm text-gray-500 mb-6">
            The page you are looking for does not exist or has been moved.
          </Text>
          <div className="flex gap-3 w-full">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => navigate(-1)}
            >
              Go back
            </Button>
            <Button className="flex-1" onClick={() => navigate("/")}>
              Go home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
